"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRKPropTypes = exports.StructuredContentProps = exports.MarketplaceProductCardAnalyticsPropType = exports.KetoProductCardAnalyticsPropType = exports.EntityPlacementImagePropType = exports.EntityPlacementDriverPropType = exports.EntityPlacementCtaPropType = exports.AnalyticsPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
/**
 * @module
 * @description Common PropType definitions. These should only be dynamically requested in development environements.
 */

var EntityPlacementCtaPropType = _propTypes.default.shape({
  link: _propTypes.default.string,
  showIcon: _propTypes.default.bool,
  subtext: _propTypes.default.string,
  text: _propTypes.default.string,
  type: _propTypes.default.string
});
exports.EntityPlacementCtaPropType = EntityPlacementCtaPropType;
var EntityPlacementDriverPropType = _propTypes.default.shape({
  description: _propTypes.default.string,
  id: _propTypes.default.string,
  label: _propTypes.default.string,
  value: _propTypes.default.string,
  valueTooltip: _propTypes.default.string,
  valueTooltipHasHtml: _propTypes.default.bool
});
exports.EntityPlacementDriverPropType = EntityPlacementDriverPropType;
var EntityPlacementImagePropType = _propTypes.default.shape({
  alt: _propTypes.default.string,
  source: _propTypes.default.string,
  sourceLarge: _propTypes.default.string,
  sourceMedium: _propTypes.default.string
});
exports.EntityPlacementImagePropType = EntityPlacementImagePropType;
var RawAnalyticsPayloadPropType = _propTypes.default.shape({
  element_position: _propTypes.default.number,
  section_name: _propTypes.default.string,
  section_position: _propTypes.default.number,
  entity_name: _propTypes.default.string,
  element_name: _propTypes.default.string
});
var AnalyticsConfigPropType = _propTypes.default.shape({
  elementPosition: _propTypes.default.number,
  entityName: _propTypes.default.string,
  sectionName: _propTypes.default.string,
  sectionPosition: _propTypes.default.number
});
var AnalyticsPropType = _propTypes.default.oneOfType([AnalyticsConfigPropType, _propTypes.default.shape({
  payload: RawAnalyticsPayloadPropType
})]);
exports.AnalyticsPropType = AnalyticsPropType;
var KetoProductCardAnalyticsPropType = _propTypes.default.shape({
  productImpressionProps: AnalyticsPropType,
  imageAndRatingProps: AnalyticsPropType,
  /**
   * @todo should this be "driversProps" like the MPC?
   */
  driverProps: AnalyticsPropType,
  accordionProps: _propTypes.default.shape({
    ourTakeProps: AnalyticsPropType,
    productDetailsProps: AnalyticsPropType
  })
});
exports.KetoProductCardAnalyticsPropType = KetoProductCardAnalyticsPropType;
var MarketplaceProductCardAnalyticsPropType = _propTypes.default.shape({
  productImpressionProps: AnalyticsPropType,
  contentProps: {
    expandableContentProps: AnalyticsPropType,
    tabContentProps: AnalyticsPropType,
    tabProps: {
      onClickProps: AnalyticsPropType,
      onTabClickProps: AnalyticsPropType
    }
  },
  driversProps: AnalyticsPropType,
  headerProps: AnalyticsPropType,
  loaCtaProps: AnalyticsPropType,
  matchScoreCTAProps: AnalyticsPropType,
  productCtaProps: AnalyticsPropType
});
exports.MarketplaceProductCardAnalyticsPropType = MarketplaceProductCardAnalyticsPropType;
var StructuredContentProps = _propTypes.default.shape({
  type: _propTypes.default.string,
  version: _propTypes.default.string
});
exports.StructuredContentProps = StructuredContentProps;
StructuredContentProps.props = _propTypes.default.shape({
  children: _propTypes.default.oneOfType([_propTypes.default.string, StructuredContentProps])
});
var TRKPropTypes = _propTypes.default.shape({
  /** Taxonomy page type. */
  pageType: _propTypes.default.string,
  /** Taxonomy topic. */
  topic: _propTypes.default.string,
  /** Taxonomy vertical. */
  vertical: _propTypes.default.string
});
exports.TRKPropTypes = TRKPropTypes;